export default __webpack_public_path__ + "static/media/login-bg.81891863.png";